import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { SceneOutcomeRelation } from '../models/SceneOutcomeRelation'
import { NgForm } from '@angular/forms';
import { API_SETTINGS } from './API_SETTINGS';

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};

const apiUrl = API_SETTINGS.API_URL + 'SceneOutcomeRelation';

@Injectable({
  providedIn: 'root'
})
export class ApiSceneOutcomeRelationService {

  constructor(private http: HttpClient) { }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  getSceneOutcomeRelations (): Observable<SceneOutcomeRelation[]> {
    const url = apiUrl +'/GetSceneOutcomeRelations'
    return this.http.get<SceneOutcomeRelation[]>(url).pipe();
  }
  
  getSceneOutcomeRelation(id: number): Observable<SceneOutcomeRelation> {
    const url = `${apiUrl}/GetSceneOutcomeRelation/${id}`;
    return this.http.get<SceneOutcomeRelation>(url).pipe();
  }

  getSceneOutcomeRelationsWithSceneId(id: number): Observable<SceneOutcomeRelation[]> {
    const url = `${apiUrl}/GetSceneOutcomeRelationsWithSceneId/${id}`;
    return this.http.get<SceneOutcomeRelation[]>(url).pipe();
  }

  addSceneOutcomeRelation(SceneOutcomeRelation: SceneOutcomeRelation): Observable<SceneOutcomeRelation>{  
    const url = apiUrl +'/PostSceneOutcomeRelation'
    return this.http.post<SceneOutcomeRelation>(url, SceneOutcomeRelation, httpOptions).pipe();
  }
  
  updateSceneOutcomeRelation (id: number, SceneOutcomeRelation: any): Observable<SceneOutcomeRelation>{
     const url = `${apiUrl}/PutSceneOutcomeRelation/${id}`;
    return this.http.put(url, SceneOutcomeRelation, httpOptions).pipe(
      tap((SceneOutcomeRelationRes: SceneOutcomeRelation) => true ), //console.log()),
      catchError(this.handleError<SceneOutcomeRelation>('updateSceneOutcomeRelation'))
    )
  }
 
  deleteSceneOutcomeRelation(id: number): Observable<SceneOutcomeRelation> {
    const url = `${apiUrl}/DeleteSceneOutcomeRelation/${id}`;
    return this.http.delete<SceneOutcomeRelation>(url, httpOptions).pipe();
  }
  
}
